module.exports = __webpack_public_path__ + "image/1.1782790484418.png";